import SwitchCountry from "./SwitchCountry";
import formatPrismicData from "../../hocs/formatPrismicData";

export default formatPrismicData(SwitchCountry);
